import { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Button } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import TypeFilter from 'components/FilterFields/TypeFilter';
import BedFilter from 'components/FilterFields/BedFilter';
import BathFilter from 'components/FilterFields/BathFilter';
import CarSpacesFilter from 'components/FilterFields/CarSpacesFilter';
import PriceFilter from 'components/FilterFields/PriceFilter';
import DateFilter from 'components/FilterFields/DateFilter';
import FilterActions from 'components/Filters/FilterActions';
import Colors from 'constants/colors';
import AdvancedFilterModal from 'components/Filters/AdvancedFilterModal';
import { LABELS, RENTALS } from 'constants/comparableTypes';
import PropertyTypes from 'constants/propertyTypes';
import { trackAdvancedFilters } from 'lib/MixpanelUtil';
import useFiltersJsonOptions from 'hooks/useFiltersJsonOptions';

function FiltersV2(props) {
    const [open, setOpen] = useState(false);

    useFiltersJsonOptions(props.comparableType);

    const handleAdvancedFilterModal = (value) => {
        setOpen((prev) => value === undefined ? !prev : value);
        if (value === true) {
            trackAdvancedFilters(props.comparableType, props.propertyId);
        }
    };

    return (
        <Container
            sx={{
                '&.MuiContainer-root': {
                    marginBottom: 4,
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 1.25,
                }}
            >
                <Box sx={{display: 'flex', gap: 1.25}}>
                    <TypeFilter
                        comparableType={props.comparableType}
                        types={PropertyTypes}
                        attr="propertyType"
                    />
                    <BedFilter comparableType={props.comparableType} />
                    <BathFilter comparableType={props.comparableType} />
                    <CarSpacesFilter comparableType={props.comparableType} />
                    <PriceFilter
                        label={`${LABELS[props.comparableType]} Price`}
                        attrName="price"
                        comparableType={props.comparableType}
                        subLabel="Select an option or manually enter a value"
                        isDropdown
                        hasRentalFrequencyTabs={props.comparableType === RENTALS}
                    />
                    <DateFilter
                        comparableType={props.comparableType}
                        label={`${LABELS[props.comparableType]} Date`}
                        attr="date"
                    />
                </Box>
                <Button
                    variant="outlined"
                    color="tertiary"
                    startIcon={<FilterListIcon />}
                    sx={{
                        color: Colors.BLACK_60_OPAQUE,
                    }}
                    onClick={() => handleAdvancedFilterModal(true)}
                >
                    Filters
                </Button>
                <FilterActions
                    comparableType={props.comparableType}
                    withReset
                    applyFilter={props.applyFilter}
                />
            </Box>
            <AdvancedFilterModal
                open={open}
                handleAdvancedFilterModal={handleAdvancedFilterModal}
                comparableType={props.comparableType}
                applyFilter={props.applyFilter}
            />
        </Container>
    );
}

FiltersV2.propTypes = {
    comparableType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    applyFilter: PropTypes.func.isRequired,
    propertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default memo(FiltersV2);